class API {
    static callAPI(endpoint, method = 'GET', body = undefined) {
        let bodyContent = body;
        if (bodyContent) bodyContent = JSON.stringify(bodyContent);
        return fetch('http://test.coludziepowiedza.co/backend/' + endpoint, { method: method, body: bodyContent })
            .then(data => data.json())
            .then(data => {
                if (data['error'] === 401) {
                    setTimeout(() => {
                        window.location.assign(data['authorization_url']);
                    }, 200);
                }
                return data;
            })
            .catch(error => console.log(error));
    }
}

export default API;